export const GET_GOOGLE = "GET_GOOGLE";
export const GET_GOOGLE_SUCCESS = "GET_GOOGLE_SUCCESS";
export const GET_GOOGLE_FAIL = "GET_GOOGLE_FAIL";

export const ADD_GOOGLE_SUCCESS = "ADD_GOOGLE_SUCCESS";
export const ADD_GOOGLE_FAIL = "ADD_GOOGLE_FAIL";
export const UPDATE_GOOGLE_SUCCESS = "UPDATE_GOOGLE_SUCCESS";
export const DELETE_GOOGLE_SUCCESS = "DELETE_GOOGLE_SUCCESS";
